import * as PIXI from "pixi.js";
import _  from "lodash";
import Display from "./Display.js";
import Events from "../events/Events.js";
import LayoutReactivePoint from "./LayoutReactivePoint.js";
import ResponsiveProps from "./ResponsiveProps.js";
import {gsap, Linear} from "gsap";



export default class GraphicsResponsive extends PIXI.Graphics
{
    get moveX ()
    {
        return this.responsive.params.x.gravity;
    }

    set moveX (val)
    {
        this.responsive.params.x.gravity = val;

        let {width, height} = Display.getCanvasSize();
        this.layout(width, height);
    }

    get moveY ()
    {
        return this.responsive.params.y.gravity;
    }

    set moveY (val)
    {
        this.responsive.params.y.gravity = val;

        let {width, height} = Display.getCanvasSize();
        this.layout(width, height);
    }


    constructor (responsive)
    {
        super();

        this.createClosure();

        this.responsive = this.normalizeResponsive(responsive);

        this.lastAnimate = Date.now();


        if (this.responsive.anchor)
            this.anchor = this.responsive.anchor;



        if (this.responsive.params)
        {
            this.ptStart = {x: this.responsive.params.x.gravity, y: this.responsive.params.y.gravity};
        }

    }

    update (props)
    {
        if (!props)
            return;

        let responsiveProp = props.find( p => p.prop === "responsive");
        let responsive = responsiveProp.val;

        this.responsive = this.normalizeResponsive(responsive);
        if (this.responsive.anchor)
            this.anchor = this.responsive.anchor;


        let {width, height} = Display.getCanvasSize();
        this.layout(width, height);
    }

    normalizeResponsive (responsive)
    {

        if (responsive.params)
        {
            responsive.params.x = new Gravity(responsive.params.x);
            responsive.params.y = new Gravity(responsive.params.y);

        }

        if (responsive.anchor)
        {
            if (responsive.anchor.x)
            {
                responsive.anchor.x = parseFloat(responsive.anchor.x);
            }

            if (responsive.anchor.y)
            {
                responsive.anchor.y = parseFloat(responsive.anchor.y);
            }
        }

        if (responsive.scale)
        {
            if (responsive.scale.x)
            {
                responsive.scale.x = parseFloat(responsive.scale.x);
            }

            if (responsive.scale.y)
            {
                responsive.scale.y = parseFloat(responsive.scale.y);
            }
        }

        return responsive;
        //return new ResponsiveProps (responsive);
    }

    createClosure ()
    {
        //this.fctReactToLayout   = this.reactToLayout.bind(this);
        // this.fctSetGravity      = this.setGravity.bind(this);
        // this.fctSetAnchor       = this.setAnchor.bind(this);
        // this.fctSetScale        = this.setScale.bind(this);
    }

    reactToLayout (val, pt, callback, prop, obj)
    {
        callback(pt, val, prop)
    }

    get gravity ()
    {
        // let size = this.getStageSize();
        // //TODO take params and check using
        //
        // let x = this.x / size.width;
        // let y = this.y / size.height;
        //
        // if (this.ptGravity)
        //     this.ptGravity.off(Events.ReactivePoint, this.fctReactToLayout);
        //
        // this.ptGravity = new LayoutReactivePoint(x, y, this.fctSetGravity);
        // this.ptGravity.on(Events.ReactivePoint, this.fctReactToLayout);
        //
        // return this.ptGravity;

        // this.responsive.params.x.gravity = pt.x;
        // this.responsive.params.y.gravity = pt.y;

        return {x: this.responsive.params.x.gravity, y: this.responsive.params.y.gravity};
    }



    // get anchor ()
    // {
    //     if (this.ptAnchor)
    //         this.ptAnchor.off(Events.ReactivePoint, this.fctSetAnchor);
    //
    //     this.ptAnchor = new LayoutReactivePoint(super.anchor.x, super.anchor.y, this.fctSetAnchor);
    //     this.ptAnchor.on(Events.ReactivePoint, this.fctReactToLayout);
    //
    //     return this.ptAnchor;
    // }
    //
    // set anchor (val)
    // {
    //     super.anchor = val;
    //
    //     this.setAnchor(val);
    //     //this.responsive.anchor = val;
    //
    // }
    //
    // setAnchor (pt)
    // {
    //     console.log("setAnchor", pt);
    //
    //     this.responsive.anchor = pt;
    //
    //     super.anchor = pt;
    // }


    // get scale ()
    // {
    //     if (this.ptScale)
    //         this.ptScale.off(Events.ReactivePoint, this.fctSetScale);
    //
    //     this.ptScale = new LayoutReactivePoint(this.responsive.scale.x, this.responsive.scale.y, this.fctSetScale);
    //     this.ptScale.on(Events.ReactivePoint, this.fctReactToLayout);
    //
    //     return this.ptScale;
    // }
    //
    // set scale (val)
    // {
    //     //super.scale = val;
    //
    //     this.setScale(val);
    //     //this.responsive.anchor = val;
    //
    // }
    //
    // setScale(pt)
    // {
    //     console.log("setScale", pt);
    //
    //     // let {width, height} = this.getStageSize();
    //     // let ratio = this.getScaleRelativeRatio(width, height);
    //
    //     this.responsive.scale.x = pt.x;
    //     this.responsive.scale.y = pt.y;
    //
    //
    // }

    getStageSize ()
    {
        return Display.instance.getCanvasSize();
    }

    enableDrag ()
    {
        this.fctStartDrag = (e) => this.startDrag(e);
        this.fctDrag = (e) => this.onDrag(e);
        this.fctStopDrag = (e) => this.onStopDrag(e);

        this.fctKey = (e) => this.onKey(e);

        this.on("pointerdown", this.fctStartDrag)
       // this.on("click", () => console.log(this.responsive))

        this.buttonMode = true;
        this.interactive = true;
    }

    startDrag (e)
    {


        document.addEventListener("pointermove", this.fctDrag );
        document.addEventListener("pointerup", this.fctStopDrag);
        document.addEventListener('keydown', this.fctKey);

        this.offset = {x: this.x - e.data.global.x, y: this.y - e.data.global.y};

        this.gfxAnchor = new PIXI.Graphics();
        this.gfxAnchor.beginFill(0x009900, 1);
        this.gfxAnchor.drawCircle(0,0, 20);
        this.gfxAnchor.endFill();

        this.addChild(this.gfxAnchor);

    }

    onDrag (e)
    {

        //this.x = e.data.global.x + this.offset.x;
        this.x = e.clientX + this.offset.x;
        //this.y = e.data.global.y + this.offset.y;
        this.y = e.clientY + this.offset.y;


    }




    ratioOfSize (pt)
    {
        let width = this.width * parseFloat(this.responsive.scale.x.baseValue) / window.innerHeight;
        let height = this.height * parseFloat(this.responsive.scale.y.baseValue) / window.innerHeight;

        return {x: width, y: height}
    }



    getScaleRelativeRatio (width, height, scale)
    {
        let canvasSize = Display.getCanvasSize();

        width = width || canvasSize.width;
        height = height || canvasSize.height;

        let size = {width, height};

        let iRatioX = 1;
        let iRatioY = 1;

        if (scale && scale.relative)
        {
            if (scale.relative.x)
            {
                let relativeTo = scale.relative.x.to;

                //if relativeTo is self, we just want to keep it has is
                if (relativeTo === "width" || relativeTo === "height")
                {
                    let iBaseValue = scale.relative.x.baseValue;

                    iRatioX = size[relativeTo] / iBaseValue;
                }

            }

            if (scale.relative.y)
            {
                let relativeTo = scale.relative.y.to;

                //if relativeTo is self, we just want to keep it has is
                if (relativeTo === "width" || relativeTo === "height")
                {
                    let iBaseValue = scale.relative.y.baseValue;

                    iRatioY = size[relativeTo] / iBaseValue;
                }
            }
        }

        return {x: iRatioX, y:iRatioY};

    }

    findSizeScale (scales, width, height)
    {
        for (let i = 0; i < scales.length; i++)
        {
            let scale = scales[i];

            let when = scale.when.replace("width", width);;

            let isScale = eval(when);

            if (isScale)
                return scale;

        }

        return null;
    }
    layout (width, height)
    {
        width = width || window.innerWidth;
        height = height || window.innerHeight;

        let size = {width, height};

        let superScale = super.scale;//for debug

        if (this.responsive.scale)
        {
            let ratio = this.getScaleRelativeRatio(width, height, this.responsive.scale);


            super.scale.x = this.responsive.scale.x * ratio.x;
            super.scale.y = this.responsive.scale.y * ratio.y;
        }
        else if (this.responsive.scales)
        {
            let scale = this.findSizeScale(this.responsive.scales, width, height);

            if (scale)
            {
                let ratio = this.getScaleRelativeRatio(width, height, scale);


                super.scale.x = scale.x * ratio.x;
                super.scale.y = scale.y * ratio.y;
            }
        }

        if (this.responsive.screen)
        {
            let strBasedOn = this.responsive.screen.scale;

            if (strBasedOn === "width")
            {
                this.width = width;
                this.scale.y = this.scale.x;
            }
            else if (strBasedOn === "height")
            {
                this.height = height;
                this.scale.x = this.scale.y;
            }
            else if (strBasedOn === "fillscreen")
            {
                let originalSize = this._texture.orig;

                let originalRatio = originalSize.width / originalSize.height;
                let currentRatio = width / height;

                //if currentRatio is larger than originalRatio, means that we must fill using width
                if (currentRatio > originalRatio)
                {
                    this.width = width;
                    this.scale.y = this.scale.x;
                }
                //if currentRatio is smaller than originalRatio, means that we must fill using height
                else
                {
                    this.height = height;
                    this.scale.x = this.scale.y;
                }


            }
        }

        for (let strKey in this.responsive.params)
        {
            let param = this.responsive.params[strKey];
            let gravity = param.gravity;
            let using = size[param.using];

            if (param.using === "pixel")
            {
                this[strKey] = this.evaluateGravity(gravity, width, height);
            }
            else
            {
                let using = size[param.using];
                this[strKey] = gravity * using;
            }


        }




    }


    evaluateGravity (gravity, width, height)
    {
        if (typeof(gravity.replace) !== "function")
            return gravity;

        gravity = gravity.replace("w", width);
        gravity = gravity.replace("h", height);
        gravity = gravity.replace("px", "");

        return eval(gravity);
    }

    getCenter ()
    {
        let bounds = this.getBounds();

        return { x: bounds.x + bounds.width / 2, y: bounds.y + bounds.height / 2};
    }

    getOrientation ()
    {
        let orientation = {x: 1, y: 1};

        if (this.scale.x < 0)
        {
            orientation.x = -1;
        }

        if (this.scale.y < 0)
        {
            orientation.y = -1;
        }

        return orientation;
    }

    tweenAnimate (arrPos)
    {
        this.fct = this.layout.bind(this);

        this.timeline = gsap.timeline({repeat: -1, repeatDelay: 0, onUpdate: this.fct});

        let startX = this.responsive.params.x.gravity;
        let startY = this.responsive.params.y.gravity;

        for (let i = 0; i < arrPos.length; i++)
        {
            this.timeline.to(this.responsive.params.x, {duration: arrPos[i].duration, gravity: startX + arrPos[i].x , ease:Linear.easeNone}, "move" + i);
            this.timeline.to(this.responsive.params.y, {duration: arrPos[i].duration, gravity: startY + arrPos[i].y , ease:Linear.easeNone}, "move" + i);
        }
    }

    intervalAnimate (arrPos, fps)
    {
        let now = Date.now();
        let elapsed = now - this.lastAnimate;
        let frame = 1000 / fps;

        if (elapsed < frame)
        {
            requestAnimationFrame( () => this.intervalAnimate(arrPos, fps));
            return;
        }
        this.lastAnimate = now;


        let pos = arrPos.shift();

        arrPos.push(pos);

        requestAnimationFrame( () => this.intervalAnimate(arrPos, fps));

        this.responsive.params.x.gravity =  this.ptStart.x +  pos.x;
        this.responsive.params.y.gravity =  this.ptStart.y +  pos.y;

        this.layout();
    }


}


class Gravity
{
    get gravity ()
    {
        return this.m_gravity;
    }

    set gravity (val)
    {

        this.m_gravity = val;
    }

    get using ()
    {
        return this.m_using;
    }

    set using (val)
    {
        this.m_using = val;
    }


    get label ()
    {
        return this.m_label;
    }

    set label (val)
    {
        this.m_label = val;
    }

    constructor (val)
    {
        this.m_gravity = 0;
        this.m_using = 0;
        this.m_label = "";

        this.gravity = val.gravity;
        this.using = val.using;
    }
}
